export const API_ADDRESS_PROD = 'https://api.mathproficiencytest.ca';
export const API_ADDRESS_LOCAL = 'http://localhost:3030';